import { NavigateFunction } from 'react-router-dom';
import { isEmpty } from 'buyside/util/lodashAlt';

type Param = { [key: string]: string | string[] };

const defaultParams: any = {
  page: '1',
  exact_phrase_match: 'true',
  community_rating: 0,
  expected_return: 0,
  formatted_thesis: 'false',
  include_closed: 'true',
  open_access_ideas: 'false',
  recommendation: 'any',
  sort_by: 'user_updated_at',
  weekly_top_ideas: 'false',
  city: '',
  aum_range: '',
  beta_metric: '',
  completeness: 0,
  has_listed_holdings: false,
  has_completed_due_diligence: false,
  intro_request: false,
  has_supplied_references: false
};

export const sanitizeParams = (params: Param): any => {
  const newParams: any = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === '' || isEmpty(value)) return;
    if (
      String(value) !== String(defaultParams[key]) &&
      value !== '_' &&
      value !== '' &&
      value !== null
    ) {
      if (Array.isArray(value)) {
        newParams[`${key}[]`] = value.length > 1 ? value : value[0];
      } else {
        newParams[key] = value;
      }
    }
  });
  return newParams;
};

export const formatURLSearchParams = (query: Param): URLSearchParams => {
  // Individually append multiple subfilters to URLSearchParams to properly generate the query string - DAC 2022/07/11
  const searchParams = Object.entries(sanitizeParams(query)).reduce(
    (acc, [filterType, filterValue]) => {
      Array.isArray(filterValue)
        ? filterValue.forEach(value => acc.append(filterType, value))
        : acc.append(filterType, filterValue as any);

      return acc;
    },
    new URLSearchParams()
  );

  return searchParams;
};

export const redirectWithParams = (
  params: Param,
  navigate: NavigateFunction,
  pathname?: string
): any => {
  return (): any => navigate({ pathname, search: '?' + formatURLSearchParams(params).toString() });
};
